import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AuthView.vue"),
  },
  {
    path: "/",
    name: "home",
    redirect: { name: "labor-cost-collection" },
  },
  {
    path: "/users",
    name: "users",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UsersList.vue"),
  },
  {
    path: "/logs",
    name: "logs",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LogsView.vue"),
  },
  {
    path: "/document/:id/:section?",
    name: "document",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Document/DocumentView.vue"
      ),
    meta: {
      title: "Проект",
    },
    redirect: { name: "document-settings" },
    children: [
      {
        path: "settings",
        name: "document-settings",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentSettings.vue"
          ),
      },
      {
        path: "workers-total",
        name: "document-workers-total",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentWorkersTotal.vue"
          ),
      },
      {
        path: "comissioning",
        name: "document-comissioning",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentComissioning.vue"
          ),
      },
      {
        path: "drivers",
        name: "document-drivers",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentDrivers.vue"
          ),
      },
      {
        path: "transport-tariffs",
        name: "document-transport-tariffs",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentTransportTariffs.vue"
          ),
      },
      {
        path: "transport-costs",
        name: "document-transport-costs",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentTransportCosts.vue"
          ),
      },
      {
        path: "fuel-costs",
        name: "document-fuel-costs",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentFuelCosts.vue"
          ),
      },
      {
        path: "calculator",
        name: "document-calculator",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentCalculator.vue"
          ),
      },
      {
        path: "design/:module",
        name: "document-design",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentDesign.vue"
          ),
      },
    ],
  },
  {
    path: "/labor-cost-collection",
    name: "labor-cost-collection",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/LaborCostCollection.vue"
      ),
  },
  {
    path: "/machine-cost-collection",
    name: "machine-cost-collection",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/MachineCostCollection.vue"
      ),
  },
  {
    path: "/srd",
    name: "srd",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SRD/SrdIndex.vue"),
    redirect: { name: "srd-v2" },
    children: [
      {
        path: "v1",
        name: "srd-v1",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/SRD/SrdCollection.vue"
          ),
      },
      {
        path: "v2",
        name: "srd-v2",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/SRD/SrdCollectionV2.vue"
          ),
      },
      {
        path: "tech-desc/:module",
        name: "tech-desc",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Document/DocumentDesign.vue"
          ),
      },
    ],
  },
  {
    path: "/technical-supervision-calculator",
    name: "technical-supervision-calculator",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/TechnicalSupervisionCalculator.vue"
      ),
  },
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SettingsView.vue"),
  },
  {
    path: "/resource/:name/",
    name: "resource",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Resource/ResourceList.vue"
      ),
    meta: {
      title: "Resource",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
